export default "__VITE_ASSET__CUFbJ8G$__"